export default {
    ca: {
        buttonText: 'Acceptar',
        message: 'Per tal de fer el seguiment de visites al nostre lloc web, utilitzem galetes. En cap cas emmagatzemem la vostra informació personal',
    },
    es: {
        buttonText: 'Aceptar',
        message: 'Para hacer el seguimiento de visitas a nuestro sitio web, utilizamos cookies. En ningún caso almacenamos la información personal',
    },
    en: {
        buttonText: 'Ok',
        message: 'In order to track visits to our website, we use cookies. We will not store your personal information in any case',
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/footer/footer-translations.js